//OtkritieZasedaniyaRegionalnogoPravleniya
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DatePicker, InputNumber, Form, Input, Select } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import locale from 'antd/es/date-picker/locale/ru_RU';

import REDUX_ZasedaniyaRegionalnogoPravleniya from '../../../objects/ZasedaniyaRegionalnogoPravleniya/reducer'
import REDUX_DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya from '../../../objects/DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya/reducer'
dayjs.locale('ru');
const { Option } = Select;


export default function OtkritieZasedaniyaRegionalnogoPravleniya(props) {

    const { object, zasedanie, prisutstvuyushchie } = props;
    // const prisutstvuyushchie = useSelector(REDUX_DokumentPrisutstvuyushchieNaZasedaniiRegPravleniya.selector.arrayByKey(zasedanie.ID));

    const options = [...prisutstvuyushchie].sort((a, b) => {
        var ai = a.chlenFederatsii.user.lastname + " " + a.chlenFederatsii.user.firstname + " " + a.chlenFederatsii.user.patronymic;
        var bi = b.chlenFederatsii.user.lastname + " " + b.chlenFederatsii.user.firstname + " " + b.chlenFederatsii.user.patronymic;
        if (ai < bi) {
            return -1;
        }
        if (ai > bi) {
            return 1;
        }
        // a должно быть равным b
        return 0;
    }).map(i => (
        <Option key={i.ID} value={i.ID}>{i.chlenFederatsii.user.lastname + " " + i.chlenFederatsii.user.firstname + " " + i.chlenFederatsii.user.patronymic}</Option>
    ));
    const president = prisutstvuyushchie.find(record => record.predsedatelPravleniyaRegionalnogoOtdeleniyaID);
    var presidentID = undefined;
    const revizor = prisutstvuyushchie.find(record => record.revizorRegionalnogoOtdeleniyaID);
    var revizorID = undefined;
    if (president) presidentID = president.ID;
    if (revizor) revizorID = revizor.ID;

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                dataNachalaZasedaniya: dayjs(),
                neobkhodimiiKvorum: zasedanie.neobkhodimiiKvorum,
                zasedanieRegionalnogoPravleniyaID: zasedanie.ID,
                predsedatelZasedaniyaID: presidentID,
                sekretarZasedaniyaID: revizorID,
                kolichestvoPrisutstvuyushchikh: prisutstvuyushchie.length,
                kolichestvoPrisutstvuyushchikhChlenovPravleniya: prisutstvuyushchie.filter(record => record.chlenRegPravleniyaID || record.predsedatelPravleniyaRegionalnogoOtdeleniyaID || record.revizorRegionalnogoOtdeleniyaID).length
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"zasedanieRegionalnogoPravleniyaID"}
                label={"Заседание правления федерации"}
                rules={[{ required: true, message: 'Укажите заседание правления федерации!' }]}
            >
                <Input disabled />
            </Form.Item>
            <Form.Item
                name={"dataNachalaZasedaniya"}
                label={"Дата начала заседания"}
                rules={[{ required: true, message: 'Укажите дату начала заседания!' }]}
            >
                <DatePicker locale={locale} />
            </Form.Item>

            <Form.Item
                name={"predsedatelZasedaniyaID"}
                label={"Председатель заседания"}
                rules={[{ required: true, message: 'Укажите председателя заседания!' }]}
            >
                <Select showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>

            <Form.Item
                name={"sekretarZasedaniyaID"}
                label={"Секретарь заседания"}
                rules={[{ required: true, message: 'Укажите секретаря заседания!' }]}
            >
                <Select showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>

            <Form.Item
                name={"kolichestvoPrisutstvuyushchikh"}
                label={"Количество присутствующих"}
                rules={[{ required: true, message: 'Укажите количество присутствующих!' }]}
            >
                <InputNumber min={0} style={{ width: "50%" }} />
            </Form.Item>
            <Form.Item
                name={"kolichestvoPrisutstvuyushchikhChlenovPravleniya"}
                label={"Количество присутствующих членов правления"}
                rules={[{ required: true, message: 'Укажите количество присутствующих членов правления!' }]}
            >
                <InputNumber min={0} style={{ width: "50%" }} />
            </Form.Item>
            <Form.Item
                preserve={"true"}

                name={"neobkhodimiiKvorum"}
                label={"Необходимый кворум"}
                rules={[{ required: true, message: 'Укажите необходимый кворум!' }]}
            >
                <InputNumber disabled min={0}
                    max={100}
                    formatter={value => `${value}%`}
                    parser={value => Number.parseFloat(value.replace('%', ''))}
                    precision={2}
                    step={0.05}
                    style={{ width: "50%" }} />
            </Form.Item>

        </Form>
    );
}
